import { render } from "./PushNotificationsDetail.vue?vue&type=template&id=ea7d55c0"
import script from "./PushNotificationsDetail.vue?vue&type=script&lang=js"
export * from "./PushNotificationsDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__